import { useEffect } from "react";
import PageHeading from "../../Components/PageHeading/PageHeading";
import "./BuyCredits.css";
import Packages from "../../Components/Packages/Packages";

const BuyCredits = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PageHeading title={"PURCHASE"} />

      <section style={{ backgroundColor: "#0a273f" }} className="pb-4 pb-md-5">
        <div className="container px-4 mx-auto">
          <Packages />
        </div>
      </section>
  
    </div>
  );
};

export default BuyCredits;
